// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__gszPr","social_list":"style_social_list__YvkSj","copy_right":"style_copy_right__29gxU"};